import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ContainerTabState from './ContainerTabState';
import ContainerViewContainer from './ContainerViewContainer';

export default class ContainerTabView extends BufferTabView<ContainerTabState> {
  render(): this {
    const props = {
      containerId: this.model.get('containerId'),
    };
    renderToDOM(<ContainerViewContainer {...props} />, this.el);
    return this;
  }

  remove(): Backbone.View<ContainerTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ContainerTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
